import "../../css/widgets/widgets.css";

import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Row, Col } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import MonitorWSService from '../../services/monitorwsservice';
import { ProgressBar } from 'devextreme-react/progress-bar';
import WidgetSettings from "./widgetSettings"
import { removeWidget } from "../../redux/supervisorSlice";
import { selectionTypes } from "../utils/consts";
import WidgetTools from "./widgetTools";

function CampaignsSummary(props) {

    const { t } = useTranslation();
    const [campaigns, setCampaigns] = useState([]);
    const [maxValue, setMaxValue] = useState(0);
    const [showSettings, setShowSettings] = useState(false);
    const [groupId, setGroupId] = useState(-1);
    const [campaignName, setCampaignName] = useState(localStorage.getItem(`CampaignsSummary_campaignName_${props.identifier}_user${props.id}`) || t("all"));

    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts
            if (MonitorWSService?.stompClient?.connected) {

                MonitorWSService.stompClient.send(`/app/unsubscribe/campaignsstatus`, {}, JSON.stringify({
                    token: props.token,
                    widgetId: props.identifier
                }));

                MonitorWSService.stompClient.unsubscribe(`campaignsstatus_${props.identifier}`);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {

        if (props.connected) {

            let groupId = parseInt(localStorage.getItem(`CampaignsSummary_groupId_${props.identifier}_user${props.id}`) || -1);
            setGroupId(groupId);

            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/campaignsstatus_${props.identifier}/`, function (campaignsstatus) {
                if (!document.hidden && localStorage.getItem("resizing") !== "true") {
                    let data = JSON.parse(campaignsstatus.body),
                        campaignsData = Object.keys(data).map(x => data[x]),
                        maxValueData = 0;

                    campaignsData.forEach((v, i) => {
                        maxValueData += v.occurrences;
                    });

                    campaignsData.forEach((v, i) => {
                        let percentage = Math.round((v.occurrences / maxValueData) * 100);
                        v.percentage = isNaN(percentage) ? 0 : percentage;
                    });

                    setCampaigns(campaignsData);
                    setMaxValue(maxValueData);
                }
            }, { id: `campaignsstatus_${props.identifier}` });

            MonitorWSService.stompClient.send("/app/subscribe/campaignsstatus", {}, JSON.stringify({
                token: props.token,
                widgetId: props.identifier,
                groupId: groupId
            }));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected]);

    const statusFormat = (ratio) => {
        return `${Math.round(ratio * 100)}%`;
    }

    const toggleSettings = () => {
        setShowSettings(!showSettings);
    };

    const setCampaign = (groupId, campaignName) => {
        setShowSettings(!showSettings);
        setGroupId(groupId);
        setCampaignName(campaignName);
        localStorage.setItem(`CampaignsSummary_groupId_${props.identifier}_user${props.id}`, groupId);
        localStorage.setItem(`CampaignsSummary_campaignName_${props.identifier}_user${props.id}`, campaignName);
        MonitorWSService.stompClient.send("/app/subscribe/campaignsstatus", {}, JSON.stringify({
            token: props.token,
            groupId: groupId,
            widgetId: props.identifier
        }));

    };

    const closeWidget = (e) => {
        e.preventDefault();
        props.close(props.identifier);
    }


    return (
        <div className={"card card-flush overflow-hidden h-lg-20 widget-container"} >
            <div className="card-header">
                <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("chart-simple")} rotation={90} /> {t("campaignssummary")} - {campaignName}</span>
                </h3>
                <div className="card-toolbar" style={{ zIndex: 9999 }}>
                    <WidgetTools key={`tools_${props.identifier}`} closeWidget={closeWidget} toggleSettings={toggleSettings}></WidgetTools>
                </div>

            </div>
            <div className="card-body" style={{ "padding": "0rem 2.25rem" }}>

                {
                    campaigns.map(c => {
                        return <Row key={c.name}>
                            <Col lg={4} >
                                <span style={{ lineHeight: "45px" }} className="fs-3 text-gray-800 fw-semibold mb-7">{t(c.name)}</span>
                            </Col>
                            <Col lg={6}>
                                <ProgressBar
                                    id="progress-bar-status"
                                    className="campprogress"
                                    width="90%"
                                    height={"45px"}
                                    min={0}
                                    max={maxValue}
                                    value={c.occurrences}
                                    showStatus={false}
                                    statusFormat={statusFormat}
                                    rtlEnabled={props.rtl}
                                />
                            </Col>
                            <Col lg={2}>
                                <span style={{ lineHeight: "45px" }} className="card-label fw-bold text-gray-800">{c.percentage}%</span>
                            </Col>
                        </Row>
                    })
                }
            </div>
            <WidgetSettings key={`settings_${props.identifier}`} showSettings={showSettings} toggleSettings={toggleSettings} token={props.token} setCampaign={setCampaign} groupId={groupId} campaignName={campaignName} selectionType={selectionTypes.CAMPAIGN}></WidgetSettings>
        </div>

    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        connected: state.parameters.connected,
        rtl: state.parameters.rtl,
        id: state.supervisor.id
    };
};

export default connect(mapStateToProps, { removeWidget })(CampaignsSummary);